/* ==========================================================================
   vm-pdp-rows — lazy loader for the product-page rows (sections/vm-pdp-rows.liquid).
   Source of truth: Redesign-2026/home-build/pdp/src/assets/vm-pdp-rows.js (review fix 2026-10-27).

   A full product page renders only <vm-pdp-rows-lazy data-url="/products/x?section_id=<section id>">.
   This fetches the same section through the Section Rendering API (where the section builds the rows) and
   replaces the shell with the returned [data-vm-pdp-rows] block. The fetch starts at whichever comes first:
     - the shell comes within 1200px of the viewport (IntersectionObserver), or
     - the page has finished loading and the browser is idle (so the rows are usually in place long before the
       visitor scrolls down, and inserting them does not push visible content: measured 2026-10-27, a 600px
       observer alone let a fast scroller see the reviews section jump by the rows' height, CLS 0.17). <vm-row> / <vm-tabs> (assets/vm-2026.js) upgrade on insert; all tabs are in the
   one response, so switching stays instant. Nothing returned (or an error) = the shell is removed, height 0.
   Fires a bubbling `vm:pdp-rows-loaded` event on the inserted block.
   ========================================================================== */
(function () {
  'use strict';
  if (!window.customElements || window.customElements.get('vm-pdp-rows-lazy')) return;

  class VmPdpRowsLazy extends HTMLElement {
    connectedCallback() {
      if (this._vmWatching || this._vmStarted) return;
      if (!this.dataset.url) return;
      if (!('IntersectionObserver' in window)) {
        this.load();
        return;
      }
      this._vmWatching = true;
      this._io = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.load();
      }, { rootMargin: '1200px 0px' });
      this._io.observe(this);
      var idle = () => {
        if ('requestIdleCallback' in window) window.requestIdleCallback(() => this.load(), { timeout: 2000 });
        else setTimeout(() => this.load(), 200);
      };
      if (document.readyState === 'complete') idle();
      else window.addEventListener('load', idle, { once: true });
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
      this._vmWatching = false;
    }

    load() {
      if (this._vmStarted || !this.isConnected) return;
      this._vmStarted = true;
      if (this._io) this._io.disconnect();
      fetch(this.dataset.url, { credentials: 'same-origin' })
        .then((response) => (response.ok ? response.text() : ''))
        .then((html) => {
          var template = document.createElement('template');
          template.innerHTML = html;
          var rows = template.content.querySelector('[data-vm-pdp-rows]');
          if (!rows || !this.isConnected) {
            this.remove();
            return;
          }
          this.replaceWith(rows);
          rows.dispatchEvent(new CustomEvent('vm:pdp-rows-loaded', { bubbles: true }));
        })
        .catch(() => {
          this.remove();
        });
    }
  }

  window.customElements.define('vm-pdp-rows-lazy', VmPdpRowsLazy);
})();
